import { apiEndpoints } from "@/services/api/api.ts";
import { LoaderFunction } from "react-router-dom";
import { studentAccountInfo } from "../types/studentAccountInfo";

export const profileLoader: LoaderFunction =
  async (): Promise<studentAccountInfo> => {
    const response = await apiEndpoints.profile();

    return response.data;
  };
